import axios from 'axios';

export default {

  listPostsByBrins(brins: string[]) {
    if (!brins) { throw Error('schoolBrins required'); }

    return axios({
      method: 'get',
      url: `${process.env.VUE_APP_WP_API_URL}/posts`,
      params: { tags: brins.join(',') },
    });
  },
};
